<mat-card fxLayout='column' fxLayoutAlign='start center'>
    <img src="../../../assets/img/static/biworklims.svg" alt="Icono Usuario">

    <h3>Política de privacidad</h3>

    <p>La funcionalidad y el servicio de esta aplicación es proporcionado por BIWORK LIMS sin costo alguno y está diseñado para usarse tal cual es.</p>
    <p>En esta página informamos a los visitantes sobre las políticas con respecto a la recopilación, el uso y la divulgación de Información personal si alguien decide utilizar este Servicio.</p>
    <p>Si elige usar este Servicio, entonces acepta la recopilación y el uso de información en relación con esta política. La información suministrada se utiliza para proporcionar y mejorar el Servicio. La misma no será compartida con nadie, más allá de cómo se describe en esta Política de privacidad.</p>

    <h3>Recopilación y uso de información</h3>

    <p>Para una mejor experiencia, mientras usa nuestro Servicio, podemos solicitarle que nos proporcione cierta información de identificación. La información se conservará en su dispositivo.</p>
    <p>La aplicación utiliza servicios de terceros que pueden recopilar información utilizada para identificarlo.</p>
    <p>Enlace a la política de privacidad de los proveedores de servicios de terceros utilizados por la aplicación</p>

    <li><a href="https://policies.google.com/privacy"> Servicios de Google Play</a></li>

    <h3>Dato de registro</h3>

    <p>Informamos que cada vez que usa nuestro Servicio, en caso de un error en la aplicación, recopilamos datos e información en su teléfono llamado Datos de registro. Estos datos de registro pueden incluir información como la dirección del Protocolo de Internet ("IP") de su dispositivo, el nombre del dispositivo, la versión del sistema operativo, la configuración de la aplicación cuando utiliza mi Servicio, la hora y la fecha de su uso del Servicio y otras estadísticas.</p>

    <h3>Cokies</h3>

    <p>Las cookies son archivos con una pequeña cantidad de datos que se utilizan comúnmente como identificadores únicos anónimos. Estos se envían a su navegador desde los sitios web que visita y se almacenan en la memoria interna de su dispositivo.</p>

    <p>Este Servicio no utiliza cookies en el dispositivo del cliente. Sin embargo, la aplicación puede usar código y bibliotecas de terceros que usan "cookies" para recopilar información y mejorar sus servicios. Tiene la opción de aceptar o rechazar estas cookies y saber cuándo se envía una cookie a su dispositivo. Si elige rechazar nuestras cookies, es posible que no pueda utilizar algunas partes de este Servicio.</p>

    <h3>Proveedores de servicio</h3>

    <p>Podemos emplear empresas e individuos de terceros debido a las siguientes razones:</p>

    <ul>
        <li> Para facilitar nuestro Servicio;</li>
        <li> Para proporcionar el Servicio en nuestro nombre;</li>
        <li>  Para realizar servicios relacionados con el Servicio;</li>
        <li>  Para ayudarnos a analizar cómo se utiliza nuestro Servicio.</li>
    </ul>

    <p>Informamos a los usuarios de este Servicio que estos terceros tienen acceso a su Información. El motivo es realizar las tareas que se les asignan en nuestro nombre. Sin embargo, están obligados a no divulgar ni utilizar la información para ningún otro fin.</p>

    <h3>Seguridad</h3>

    <p>Valoramos su confianza al proporcionarnos su información personal, por lo que nos esforzamos por utilizar medios comercialmente aceptables para protegerla. Pero recuerde que ningún método de transmisión por Internet, o método de almacenamiento electrónico es 100% seguro y confiable, y no podemos garantizar su seguridad absoluta. Para poder utilizar todas las funciones se le solicitará permiso para acceder a:</p>

    <ul>
        <li> Almacenamiento</li>        
        <li> Cámara</li>
        <li> Subscripción a notificaciones Push</li>
    </ul>

    <h3>Enlaces a otros sitios</h3>

    <p>Este Servicio puede contener enlaces a otros sitios. Si hace clic en un enlace de un tercero, será dirigido a ese sitio. Tenga en cuenta que estos sitios externos no son operados por nosotros. Por lo tanto, recomendamos encarecidamente que revise la Política de privacidad de estos sitios web. No tenemos control ni asumimos ninguna responsabilidad por su contenido, las políticas de privacidad o las prácticas de los sitios o servicios de terceros.</p>

    <h3>Privacidad de la niñez</h3>

    <p>Este Servicio no está destinado a personas menores. No registramos información a sabiendas de personas menores.</p>

    <h3>Cambios a esta Política de Privacidad</h3>

    <p>Podemos actualizar nuestra Política de privacidad. Por lo tanto, recomendamos revisar esta página periódicamente para ver si hay cambios. Notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página. Estos cambios entrarán en vigor inmediatamente después de su publicación.</p>

    <h3>Contáctenos</h3>

    <p class="pb">
        Si tienes alguna duda o sugerencia sobre esta Política de Privacidad, no dudes en contactarnos a 
        <a href="mailto:biworklab@gmail.com">biworklab&#64;gmail.com</a>
    </p>



</mat-card>    
